'use strict';

module.exports = require('../5/CheckObjectCoercible');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2019/RequireObjectCoercible.js
// module id = 660
// module chunks = 0